import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import { List, ListItem, makeStyles, Divider, Box } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import axios from 'axios';

import Header from 'components/UI/Header/Header';
import Footer from 'components/UI/Footer/Footer';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from 'react-loader-spinner';

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper
  },
  item: {
    padding: theme.spacing(1.2)
  },
  avatar: { marginRight: theme.spacing(5) },
  paginator: {
    justifyContent: "center",
    padding: "10px"
  }
}));

const Fired = props => {
  const [allJobs, setAllJobs] = useState([])
  const [errorMessage, setErrorMessage] = useState("")
  const [isLoading, setIsLoading] = useState(true)
  const [isError, setIsError] = useState(true)
  const [noOfPages, setNoOfPages] = React.useState(1)

  useEffect(() => {
      fetchAllJobs();
  }, []);

  const fetchAllJobs = () => {
      //setIsLoading(true);
      axios.get('http://localhost:8000/alljobs/')
      //axios.get('https://newboardserver.herokuapp.com/alljobs')
      .then((response) => {
          let load = (response.data)
          console.log(load)
          
          //Remove duplicate posts
          const uniqueObjects = [...new Map(load.map(item => [item.job_title, item])).values()]
          console.log(uniqueObjects)
          setAllJobs(uniqueObjects)
          setNoOfPages(Math.ceil(uniqueObjects.length / itemsPerPage))
          setIsLoading(false);
          setIsError(false)
      })
      .catch(() => {
          setErrorMessage('Error while getting data, check your network connectivity and try again')
          setIsLoading(false);
      });
  };
    const classes = useStyles();
    const itemsPerPage = 6;
    const [page, setPage] = React.useState(1);

  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <div>
      <Header />
        <br/>
        <div class="page-container row">
            <div class="col-12 col-md-11">
              <h3 align="center">LATEST TECH JOBS</h3>
              {isLoading ? (<p align="center">Data loading, please wait.. 
                      <Loader type="ThreeDots" color="#00BFFF" height={50} width={50} />
                      </p>
                    ) : (
                    <div>
                      <List dense component="span">
                        {allJobs && allJobs
                          .slice((page - 1) * itemsPerPage, page * itemsPerPage)
                          .map(jobItem => {
                            const labelId = `list-secondary-label-${jobItem.job_title}`;
                            return (
                              <ListItem
                                key={jobItem.id}
                              >
                                <div className= "card col-12 col-md-11">
                                    <div class="card-header bg-default" ><h5><b><Link to={"/latestjobs/" +jobItem.id}>
                                      {jobItem.job_title}</Link> <br/> <span className="dateformat">{jobItem.string_date}</span>
                                        </b></h5>
                                    </div>
                                          <div class="card-body">
                                              {jobItem.job_intro}
                                          </div>
                                      <div class="card-footer bg-light">
                                          Click {/*<a  href={allJobs.job_link} target="_blank">here</a>*/}
                                          <Link to={"/latestjobs/" +jobItem.id}>here</Link> for details 
                                      </div>
                                </div>
                              </ListItem>
                            );
                          })}
                      </List>
                      <br />
                      <Divider />
                      <Box component="span">
                        <Pagination
                          count={noOfPages}
                          page={page}
                          onChange={handleChange}
                          defaultPage={1}
                          color="primary"
                          size="large"
                          showFirstButton
                          showLastButton
                          classes={{ ul: classes.paginator }}
                        />
                      </Box>
                    </div>
                    )}
            </div>
          </div>
          <br/>
      <Footer />
    </div>
  );
};

export default Fired;

